<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container operation-management-window no-overflow-x"
  [attr.data-cy-specific-window-name]="name"
  [ngClass]="{ 'specific-window-fullscreen': isFullScreen }">
  <!-- ? Panel top -->
  <div class="operation-management-container apiz-p-grid">
    <!-- ? Panel top-left -->
    <div class="operation-management-panel">
      <div class="p-col-12 operation-management-inner-fieldset p-grid">
        <ng-template #top />
      </div>
      <div class="apiz-p-grid">
        <iu-prime-fieldset
          class="p-col-12"
          [collapsed]="false"
          legend="{{ 'operation-management.note' | translate }}"
          [overridedCSS]="bigLegend"
          [toggleable]="false">
          <!-- calc(13 * (1.275em)); -->
          <div class="operation-management-inner-fieldset">
            <iu-input-textarea-ui
              [fieldValue]="selectedOperation?.note"
              [isReadOnly]="!selectedOperation"
              [isStandalone]="true"
              [overridedCSS]="bigInput"
              [resize]="'none'"
              [shouldSyncHeightWithLine]="true"
              (fieldValueModified)="selectedOperation.note = $event" />
          </div>
        </iu-prime-fieldset>
      </div>
    </div>

    <!-- ? Panel top-right -->
    <div class="operation-management-panel">
      <div class="apiz-p-grid">
        @if (selectedOperation?.description) {
          <iu-prime-fieldset
            class="p-col-12"
            [collapsed]="false"
            legend="{{ 'operation-management.description' | translate }}"
            [overridedCSS]="bigLegend"
            [toggleable]="false">
            <div class="operation-management-inner-fieldset" style="font-size: 14pt">
              {{ selectedOperation?.description }}
            </div>
          </iu-prime-fieldset>
        }
      </div>
      <div class="apiz-p-grid">
        <iu-input-file-ui
          class="p-col-12"
          [canDelete]="false"
          [canPreview]="true"
          [canUpload]="false"
          [isStandalone]="true"
          [multiple]="true"
          [mustGet]="false"
          [overridedCSS]="[bigInput, bigLabel] | spreadOperator"
          [searchInformations]="[{ 'META|TYPE': 'OPERATION_MANAGEMENT_DOC' }]"
          [type]="'OPERATION_MANAGEMENT_DOC'"
          [uploadedFileList_noFiles]="'operation-management.input-file.no-files' | translate"
          [uploadedFileList_title]="'operation-management.input-file.title' | translate"
          [uploadedFiles]="selectedOperation?.attachedFile || []" />
      </div>

      @if (isLastOperation) {
        <div>
          <!-- ? produits fabriqués -->
          <iu-prime-fieldset
            [collapsed]="false"
            legend="{{ 'operation-management.products' | translate }}"
            [overridedCSS]="bigLegend"
            [toggleable]="false">
            <div class="operation-management-inner-fieldset">
              <table aria-label="products table" class="products-table">
                @if (selectedProducts) {
                  <ng-container
                    [ngTemplateOutlet]="productList"
                    [ngTemplateOutletContext]="{ products: selectedProducts, $implicit: false }" />
                } @else {
                  <ng-container
                    [ngTemplateOutlet]="productList"
                    [ngTemplateOutletContext]="{
                      products: [
                        {
                          name: 'PRODUCT',
                          QtyProduced: 0,
                          QtyToProduce: 0,
                          unit: 'operation-management.unit' | translate,
                          usedQty: 0,
                        },
                      ],
                      $implicit: true,
                    }" />
                }
              </table>
              <div class="operation-management-main-btn">
                <button class="p-button p-button-success big-btn" (click)="validateProducts()">
                  {{ 'operation-management.end' | translate }}
                </button>
                <button class="p-button p-button-info big-btn" (click)="saveProducts()">
                  {{ 'operation-management.save' | translate }}
                </button>
              </div>
            </div>
          </iu-prime-fieldset>
        </div>
      }
    </div>
  </div>
  <hr />
  <!-- ? Panel central -->
  <div class="operation-management-container apiz-p-grid">
    <!-- ? Panel central-left -->
    <div class="operation-management-panel">
      <iu-prime-fieldset
        [collapsed]="false"
        legend="{{ 'operation-management.components' | translate }}"
        [overridedCSS]="bigLegend"
        [toggleable]="false">
        <div class="operation-management-inner-fieldset">
          <table aria-label="components table" class="components-table">
            @if (selectedOperation) {
              <ng-container
                [ngTemplateOutlet]="componentList"
                [ngTemplateOutletContext]="{ components: selectedOperation.components, $implicit: false }" />
            } @else {
              <ng-container
                [ngTemplateOutlet]="componentList"
                [ngTemplateOutletContext]="{
                  components: [
                    {
                      name: 'COMPONENT',
                      QtyConsumed: 0,
                      QtyToConsume: 0,
                      unit: 'operation-management.unit' | translate,
                      usedQty: 0,
                    },
                  ],
                  $implicit: true,
                }" />
            }
          </table>
          <button
            class="p-button p-button-info big-btn"
            type="button"
            [disabled]="!selectedOperation || true"
            (click)="toggleComponentInput()">
            {{ 'operation-management.add-component' | translate }}
          </button>
        </div>
      </iu-prime-fieldset>
    </div>
    <!-- ? Panel central-right -->
    <div class="operation-management-panel">
      <iu-prime-fieldset
        [collapsed]="false"
        legend="{{ 'operation-management.ressources' | translate }}"
        [overridedCSS]="bigLegend"
        [toggleable]="false">
        <div class="operation-management-inner-fieldset">
          <table aria-label="ressources table" class="ressources-table">
            @if (selectedOperation) {
              <ng-container
                [ngTemplateOutlet]="ressourceList"
                [ngTemplateOutletContext]="{ ressources: selectedOperation.ressources, $implicit: false }" />
            } @else {
              <ng-container
                [ngTemplateOutlet]="ressourceList"
                [ngTemplateOutletContext]="{
                  ressources: [{ name: 'RESSOURCE', baseTime: 0, usedTime: 0 }],
                  $implicit: true,
                }" />
            }
          </table>
        </div>
      </iu-prime-fieldset>

      @if (hasDeltaTime) {
        <iu-prime-fieldset
          [collapsed]="false"
          legend="{{ 'operation-management.delta-time-note' | translate }}"
          [overridedCSS]="bigLegend"
          [toggleable]="false">
          <div class="operation-management-inner-fieldset">
            <iu-input-textarea-ui
              [fieldValue]="selectedOperation?.deltaTime"
              [isStandalone]="true"
              (fieldValueModified)="updateDeltaTime($event)" />
          </div>
        </iu-prime-fieldset>
      }
    </div>
    <div class="p-col-6 p-offset-6">
      <hr />
      <div class="operation-management-main-btn">
        <button
          class="p-button p-button-success big-btn"
          data-cy="btn-end-operation"
          type="button"
          [disabled]="!selectedOperation || selectedOperation.status.id === ''"
          (click)="validateOperation()">
          {{ 'operation-management.end' | translate }}
        </button>
        <button
          class="p-button p-button-info big-btn"
          data-cy="btn-save-operation"
          type="button"
          [disabled]="!selectedOperation || selectedOperation.status.id === ''"
          (click)="saveOperation()">
          {{ 'operation-management.save' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- ? Panel bottom-right -->
</div>

<!-- ? Zone des templates -->
<ng-template #componentList let-components="components" let-readOnly>
  @for (component of components; track i; let i = $index) {
    <tr [ngClass]="[readOnly ? 'read-only' : '', 'operation-management-row']">
      <td class="big-label">{{ component.name | uppercase }}</td>
      <td class="big-label">{{ component.QtyConsumed }}/{{ component.QtyToConsume }} {{ component.unit }}</td>
      <td style="width: 20%">
        <iu-input-number-ui
          [fieldValue]="component.usedQty"
          [isReadOnly]="readOnly"
          [isStandalone]="true"
          [overridedCSS]="bigInput"
          (fieldValueModified)="updateUsedQtyOperation($event, i)" />
      </td>
      <td class="btn-cell" style="width: 25%">
        <button
          class="p-button p-button-primary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedQtyOperation(1, i)">
          +
        </button>
        <button
          class="p-button p-button-secondary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedQtyOperation(-1, i)">
          -
        </button>
      </td>
    </tr>
  }

  @if (isAddingOperationComponent) {
    <ng-container [ngTemplateOutlet]="componentInput" />
  }
</ng-template>

<ng-template #componentInput>
  <tr [ngClass]="['operation-management-row']">
    <td>
      <iu-input-text-ui
        #inputTextName
        [isStandalone]="true"
        [overridedCSS]="[bigInput, bigLabel] | spreadOperator"
        [placeHolder]="'operation-management.component-item.name' | translate" />
    </td>
    <td>
      <iu-input-number-ui
        #inputNumberBaseQty
        [isStandalone]="true"
        [overridedCSS]="[bigInput, bigLabel] | spreadOperator"
        [placeHolder]="'operation-management.component-item.nb' | translate" />
    </td>
    <td>
      <iu-input-text-ui
        #inputTextUnit
        [isStandalone]="true"
        [overridedCSS]="[bigInput, bigLabel] | spreadOperator"
        [placeHolder]="'operation-management.component-item.unit' | translate" />
    </td>

    <td style="display: flex">
      <button
        class="p-button p-button-primary big-btn"
        type="button"
        (click)="
          addOperationComponent(inputTextName?.fieldValue, inputNumberBaseQty?.fieldValue, inputTextUnit?.fieldValue)
        ">
        {{ 'generic.confirm' | translate }}
      </button>
      <button class="p-button p-button-secondary big-btn" type="button" (click)="isAddingOperationComponent = false">
        {{ 'generic.cancel' | translate }}
      </button>
    </td>
  </tr>
</ng-template>

<ng-template #ressourceList let-readOnly let-ressources="ressources">
  @for (ressource of ressources; track i; let i = $index) {
    <tr [ngClass]="[readOnly ? 'read-only' : '', 'operation-management-row']">
      <td class="big-label">{{ ressource.name }}</td>
      <td class="big-label">{{ ressource.baseTime - ressource.usedTime }}/{{ ressource.baseTime }}h</td>
      <td style="width: 20%">
        <iu-input-number-ui
          [fieldValue]="ressource.usedTime"
          [isStandalone]="true"
          [overridedCSS]="bigInput"
          (fieldValueModified)="updateUsedTime($event, i)" />
      </td>
      <td class="btn-cell" style="width: 25%">
        <button
          class="p-button p-button-primary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedTime(1, i)">
          +
        </button>
        <button
          class="p-button p-button-secondary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedTime(-1, i)">
          -
        </button>
      </td>
    </tr>
  }
</ng-template>

<ng-template #productList let-products="products" let-readOnly>
  @for (product of products; track i; let i = $index) {
    <tr [ngClass]="[readOnly ? 'read-only' : '', 'operation-management-row']">
      <td class="big-label">{{ product.name }} {{ 'operation-management.unit' | translate }}</td>
      <td class="big-label">{{ product.QtyProduced }}/{{ product.QtyToProduce }} {{ product.unit }}</td>
      <td style="width: 20%">
        <iu-input-number-ui
          [fieldValue]="product.usedQty"
          [isStandalone]="true"
          [overridedCSS]="bigInput"
          (fieldValueModified)="updateUsedQtyProduct($event, i)" />
      </td>
      <td class="btn-cell" style="width: 25%">
        <button
          class="p-button p-button-primary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedQtyProduct(1, i)">
          +
        </button>
        <button
          class="p-button p-button-secondary big-btn"
          type="button"
          [disabled]="readOnly"
          (click)="changeUsedQtyProduct(-1, i)">
          -
        </button>
      </td>
    </tr>
  }
</ng-template>

<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    [isModalDisplay]="displayFormUI"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false }})">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
